import { Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const style = {
    label: {
        fontSize: '12px',
        fontFamily: 'Inter, Roboto, Arial',
        fontWeight: '600'
    }
};

export default withStyles(style)(Chip);
